<template>
  <div class="mcp-landing">
    <!-- Q1 Launch Special Banner (only show to non-premium users) -->
    <div v-if="!isPremiumUser" class="beta-promo-banner">
      <div class="container">
        <div class="promo-content">
          <div class="promo-badge">
            <span class="beta-tag">🚀 Q1 2026 LAUNCH</span>
            <span class="promo-text">Early Adopter Rate: <strong>$19/mo FOREVER</strong> • Public Launch March 31st</span>
          </div>
          <a href="#claude" class="promo-cta" @click.prevent="scrollToClaude">Claim Launch Rate →</a>
        </div>
      </div>
    </div>

    <!-- Premium User Welcome Banner -->
    <div v-if="isPremiumUser" class="premium-welcome-banner">
      <div class="container">
        <div class="premium-content">
          <div class="premium-badge">
            <span class="premium-tag">⭐ PREMIUM USER</span>
            <span class="premium-text">You have <strong>150 API calls/day</strong> • Unlimited access to all tools</span>
          </div>
          <a href="#setup" class="premium-cta" @click.prevent="scrollToSetup">Setup Instructions →</a>
        </div>
      </div>
    </div>

    <!-- Hero Section -->
    <section class="hero">
      <div class="container">
        <div class="hero-badge">
          <img src="/InvestBuddyLogo.png" alt="InvestBuddy.ai" class="hero-logo" />
        </div>
        
        <!-- Status Banner -->
        <div class="status-banner">
          <div class="status-item available">
            <svg class="status-logo" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M37.5324 16.8707C37.9808 15.5241 38.1363 14.0974 37.9886 12.6859C37.8409 11.2744 37.3934 9.91076 36.676 8.68622C35.6126 6.83404 33.9882 5.3676 32.0373 4.4985C30.0864 3.62941 27.9098 3.40259 25.8215 3.85078C24.8796 2.7893 23.7219 1.94125 22.4257 1.36341C21.1295 0.785575 19.7249 0.491269 18.3058 0.500197C16.1708 0.495044 14.0893 1.16803 12.3614 2.42214C10.6335 3.67624 9.34853 5.44666 8.6917 7.47815C7.30085 7.76286 5.98686 8.3414 4.8377 9.17505C3.68854 10.0087 2.73073 11.0782 2.02839 12.312C0.956464 14.1591 0.498905 16.2988 0.721698 18.4228C0.944492 20.5467 1.83612 22.5449 3.268 24.1293C2.81966 25.4759 2.66413 26.9026 2.81182 28.3141C2.95951 29.7256 3.40701 31.0892 4.12437 32.3138C5.18791 34.1659 6.8123 35.6322 8.76321 36.5013C10.7141 37.3704 12.8907 37.5973 14.9789 37.1492C15.9208 38.2107 17.0786 39.0587 18.3747 39.6366C19.6709 40.2144 21.0755 40.5087 22.4946 40.4998C24.6307 40.5054 26.7133 39.8321 28.4418 38.5772C30.1704 37.3223 31.4556 35.5506 32.1119 33.5179C33.5027 33.2332 34.8167 32.6547 35.9659 31.821C37.115 30.9874 38.0728 29.9178 38.7752 28.684C39.8458 26.8371 40.3023 24.6979 40.0789 22.5748C39.8556 20.4517 38.9639 18.4544 37.5324 16.8707ZM22.4978 37.8849C20.7443 37.8874 19.0459 37.2733 17.6994 36.1501C17.7601 36.117 17.8666 36.0586 17.936 36.0161L25.9004 31.4156C26.1003 31.3019 26.2663 31.137 26.3813 30.9378C26.4964 30.7386 26.5563 30.5124 26.5549 30.2825V19.0542L29.9213 20.998C29.9389 21.0068 29.9541 21.0198 29.9656 21.0359C29.977 21.052 29.9842 21.0707 29.9867 21.0902V30.3889C29.9842 32.375 29.1946 34.2791 27.7909 35.6841C26.3872 37.0892 24.4838 37.8806 22.4978 37.8849ZM6.39227 31.0064C5.51397 29.4888 5.19742 27.7107 5.49804 25.9832C5.55718 26.0187 5.66048 26.0818 5.73461 26.1244L13.699 30.7248C13.8975 30.8408 14.1233 30.902 14.3532 30.902C14.583 30.902 14.8088 30.8408 15.0073 30.7248L24.731 25.1103V28.9979C24.7321 29.0177 24.7283 29.0376 24.7199 29.0556C24.7115 29.0736 24.6988 29.0893 24.6829 29.1012L16.6317 33.7497C14.9096 34.7416 12.8643 35.0097 10.9447 34.4954C9.02506 33.9811 7.38785 32.7263 6.39227 31.0064ZM4.29707 13.6194C5.17156 12.0998 6.55279 10.9364 8.19885 10.3327C8.19885 10.4013 8.19491 10.5228 8.19491 10.6071V19.808C8.19351 20.0378 8.25334 20.2638 8.36823 20.4629C8.48312 20.6619 8.64893 20.8267 8.84863 20.9404L18.5723 26.5542L15.206 28.4979C15.1894 28.5089 15.1703 28.5155 15.1505 28.5173C15.1307 28.5191 15.1107 28.516 15.0924 28.5082L7.04046 23.8557C5.32135 22.8601 4.06716 21.2235 3.55289 19.3046C3.03862 17.3858 3.30624 15.3413 4.29707 13.6194ZM31.955 20.0556L22.2312 14.4411L25.5976 12.4981C25.6142 12.4872 25.6333 12.4805 25.6531 12.4787C25.6729 12.4769 25.6928 12.4801 25.7111 12.4879L33.7631 17.1364C34.9967 17.849 36.0017 18.8982 36.6606 20.1613C37.3194 21.4244 37.6047 22.8486 37.4832 24.2632C37.3617 25.6779 36.8382 27.0282 35.9743 28.1596C35.1103 29.291 33.9415 30.1569 32.6047 30.6562C32.6047 30.5875 32.6086 30.4661 32.6086 30.3818V21.188C32.6102 20.9586 32.5506 20.7328 32.4358 20.5338C32.321 20.3348 32.155 20.1698 31.955 20.0556ZM35.3055 15.0128C35.2464 14.9765 35.1431 14.9142 35.069 14.8717L27.1045 10.2712C26.906 10.1554 26.6802 10.0943 26.4504 10.0943C26.2206 10.0943 25.9948 10.1554 25.7963 10.2712L16.0726 15.8858V11.9982C16.0715 11.9783 16.0753 11.9585 16.0837 11.9405C16.0921 11.9225 16.1048 11.9068 16.1207 11.8949L24.1719 7.25025C25.4053 6.53903 26.8158 6.19376 28.2383 6.25482C29.6608 6.31589 31.0364 6.78077 32.2044 7.59508C33.3723 8.40939 34.2842 9.53945 34.8334 10.8531C35.3826 12.1667 35.5464 13.6095 35.3055 15.0128ZM14.2424 21.9419L10.8752 19.9981C10.8576 19.9893 10.8423 19.9763 10.8309 19.9602C10.8195 19.9441 10.8122 19.9254 10.8098 19.9058V10.6071C10.8107 9.18295 11.2173 7.78848 11.9819 6.58696C12.7466 5.38544 13.8377 4.42659 15.1275 3.82264C16.4173 3.21869 17.8524 2.99464 19.2649 3.1767C20.6775 3.35876 22.0089 3.93941 23.1034 4.85067C23.0427 4.88379 22.937 4.94215 22.8668 4.98473L14.9024 9.58517C14.7025 9.69878 14.5366 9.86356 14.4215 10.0626C14.3065 10.2616 14.2466 10.4877 14.2479 10.7175L14.2424 21.9419ZM16.071 17.9991L20.4018 15.4978L24.7325 17.9975V22.9985L20.4018 25.4983L16.071 22.9985V17.9991Z" fill="#10A37F"/></svg>
            <span class="status-text"><strong>Available Now:</strong> ChatGPT GPT</span>
          </div>
          <div class="status-item available">
            <svg class="status-logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M4.709 15.955l4.72-2.647.08-.23-.08-.128H9.2l-.79-.048-2.698-.073-2.339-.097-2.266-.122-.571-.121L0 11.784l.055-.352.48-.321.686.06 1.52.103 2.278.158 1.652.097 2.449.255h.389l.055-.157-.134-.098-.103-.097-2.358-1.596-2.552-1.688-1.336-.972-.724-.491-.364-.462-.158-1.008.656-.722.881.06.225.061.893.686 1.908 1.476 2.491 1.833.365.304.145-.103.019-.073-.164-.274-1.355-2.446-1.446-2.49-.644-1.032-.17-.619a2.97 2.97 0 01-.104-.729L6.283.134 6.696 0l.996.134.42.364.62 1.414 1.002 2.229 1.555 3.03.456.898.243.832.091.255h.158V9.01l.128-1.706.237-2.095.23-2.695.08-.76.376-.91.747-.492.584.28.48.685-.067.444-.286 1.851-.559 2.903-.364 1.942h.212l.243-.242.985-1.306 1.652-2.064.73-.82.85-.904.547-.431h1.033l.76 1.129-.34 1.166-1.064 1.347-.881 1.142-1.264 1.7-.79 1.36.073.11.188-.02 2.856-.606 1.543-.28 1.841-.315.833.388.091.395-.328.807-1.969.486-2.309.462-3.439.813-.042.03.049.061 1.549.146.662.036h1.622l3.02.225.79.522.474.638-.079.485-1.215.62-1.64-.389-3.829-.91-1.312-.329h-.182v.11l1.093 1.068 2.006 1.81 2.509 2.33.127.578-.322.455-.34-.049-2.205-1.657-.851-.747-1.926-1.62h-.128v.17l.444.649 2.345 3.521.122 1.08-.17.353-.608.213-.668-.122-1.374-1.925-1.415-2.167-1.143-1.943-.14.08-.674 7.254-.316.37-.729.28-.607-.461-.322-.747.322-1.476.389-1.924.315-1.53.286-1.9.17-.632-.012-.042-.14.018-1.434 1.967-2.18 2.945-1.726 1.845-.414.164-.717-.37.067-.662.401-.589 2.388-3.036 1.44-1.882.93-1.086-.006-.158h-.055L4.132 18.56l-1.13.146-.487-.456.061-.746.231-.243 1.908-1.312-.006.006z" fill="#D97757" fill-rule="nonzero"/></svg>
            <span class="status-text"><strong>Available Now:</strong> Claude Desktop</span>
          </div>
        </div>

        <div class="hero-content">
          <div class="hero-text">
            <h1>Use InvestBuddy AI in <span class="gradient-text">ChatGPT</span> & <span class="gradient-text">Claude</span></h1>
            <p class="subtitle">
              Get 55.41% validated win rate stock predictions directly in your AI assistant. 
              Real backtest results with 241 trades over 4 years. 
              No app switching, no copy-paste. Just natural conversation.
            </p>
            <div class="cta-buttons">
              <a href="#chatgpt" class="btn-primary">
                <svg class="btn-icon" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M37.5324 16.8707C37.9808 15.5241 38.1363 14.0974 37.9886 12.6859C37.8409 11.2744 37.3934 9.91076 36.676 8.68622C35.6126 6.83404 33.9882 5.3676 32.0373 4.4985C30.0864 3.62941 27.9098 3.40259 25.8215 3.85078C24.8796 2.7893 23.7219 1.94125 22.4257 1.36341C21.1295 0.785575 19.7249 0.491269 18.3058 0.500197C16.1708 0.495044 14.0893 1.16803 12.3614 2.42214C10.6335 3.67624 9.34853 5.44666 8.6917 7.47815C7.30085 7.76286 5.98686 8.3414 4.8377 9.17505C3.68854 10.0087 2.73073 11.0782 2.02839 12.312C0.956464 14.1591 0.498905 16.2988 0.721698 18.4228C0.944492 20.5467 1.83612 22.5449 3.268 24.1293C2.81966 25.4759 2.66413 26.9026 2.81182 28.3141C2.95951 29.7256 3.40701 31.0892 4.12437 32.3138C5.18791 34.1659 6.8123 35.6322 8.76321 36.5013C10.7141 37.3704 12.8907 37.5973 14.9789 37.1492C15.9208 38.2107 17.0786 39.0587 18.3747 39.6366C19.6709 40.2144 21.0755 40.5087 22.4946 40.4998C24.6307 40.5054 26.7133 39.8321 28.4418 38.5772C30.1704 37.3223 31.4556 35.5506 32.1119 33.5179C33.5027 33.2332 34.8167 32.6547 35.9659 31.821C37.115 30.9874 38.0728 29.9178 38.7752 28.684C39.8458 26.8371 40.3023 24.6979 40.0789 22.5748C39.8556 20.4517 38.9639 18.4544 37.5324 16.8707ZM22.4978 37.8849C20.7443 37.8874 19.0459 37.2733 17.6994 36.1501C17.7601 36.117 17.8666 36.0586 17.936 36.0161L25.9004 31.4156C26.1003 31.3019 26.2663 31.137 26.3813 30.9378C26.4964 30.7386 26.5563 30.5124 26.5549 30.2825V19.0542L29.9213 20.998C29.9389 21.0068 29.9541 21.0198 29.9656 21.0359C29.977 21.052 29.9842 21.0707 29.9867 21.0902V30.3889C29.9842 32.375 29.1946 34.2791 27.7909 35.6841C26.3872 37.0892 24.4838 37.8806 22.4978 37.8849ZM6.39227 31.0064C5.51397 29.4888 5.19742 27.7107 5.49804 25.9832C5.55718 26.0187 5.66048 26.0818 5.73461 26.1244L13.699 30.7248C13.8975 30.8408 14.1233 30.902 14.3532 30.902C14.583 30.902 14.8088 30.8408 15.0073 30.7248L24.731 25.1103V28.9979C24.7321 29.0177 24.7283 29.0376 24.7199 29.0556C24.7115 29.0736 24.6988 29.0893 24.6829 29.1012L16.6317 33.7497C14.9096 34.7416 12.8643 35.0097 10.9447 34.4954C9.02506 33.9811 7.38785 32.7263 6.39227 31.0064ZM4.29707 13.6194C5.17156 12.0998 6.55279 10.9364 8.19885 10.3327C8.19885 10.4013 8.19491 10.5228 8.19491 10.6071V19.808C8.19351 20.0378 8.25334 20.2638 8.36823 20.4629C8.48312 20.6619 8.64893 20.8267 8.84863 20.9404L18.5723 26.5542L15.206 28.4979C15.1894 28.5089 15.1703 28.5155 15.1505 28.5173C15.1307 28.5191 15.1107 28.516 15.0924 28.5082L7.04046 23.8557C5.32135 22.8601 4.06716 21.2235 3.55289 19.3046C3.03862 17.3858 3.30624 15.3413 4.29707 13.6194ZM31.955 20.0556L22.2312 14.4411L25.5976 12.4981C25.6142 12.4872 25.6333 12.4805 25.6531 12.4787C25.6729 12.4769 25.6928 12.4801 25.7111 12.4879L33.7631 17.1364C34.9967 17.849 36.0017 18.8982 36.6606 20.1613C37.3194 21.4244 37.6047 22.8486 37.4832 24.2632C37.3617 25.6779 36.8382 27.0282 35.9743 28.1596C35.1103 29.291 33.9415 30.1569 32.6047 30.6562C32.6047 30.5875 32.6086 30.4661 32.6086 30.3818V21.188C32.6102 20.9586 32.5506 20.7328 32.4358 20.5338C32.321 20.3348 32.155 20.1698 31.955 20.0556ZM35.3055 15.0128C35.2464 14.9765 35.1431 14.9142 35.069 14.8717L27.1045 10.2712C26.906 10.1554 26.6802 10.0943 26.4504 10.0943C26.2206 10.0943 25.9948 10.1554 25.7963 10.2712L16.0726 15.8858V11.9982C16.0715 11.9783 16.0753 11.9585 16.0837 11.9405C16.0921 11.9225 16.1048 11.9068 16.1207 11.8949L24.1719 7.25025C25.4053 6.53903 26.8158 6.19376 28.2383 6.25482C29.6608 6.31589 31.0364 6.78077 32.2044 7.59508C33.3723 8.40939 34.2842 9.53945 34.8334 10.8531C35.3826 12.1667 35.5464 13.6095 35.3055 15.0128ZM14.2424 21.9419L10.8752 19.9981C10.8576 19.9893 10.8423 19.9763 10.8309 19.9602C10.8195 19.9441 10.8122 19.9254 10.8098 19.9058V10.6071C10.8107 9.18295 11.2173 7.78848 11.9819 6.58696C12.7466 5.38544 13.8377 4.42659 15.1275 3.82264C16.4173 3.21869 17.8524 2.99464 19.2649 3.1767C20.6775 3.35876 22.0089 3.93941 23.1034 4.85067C23.0427 4.88379 22.937 4.94215 22.8668 4.98473L14.9024 9.58517C14.7025 9.69878 14.5366 9.86356 14.4215 10.0626C14.3065 10.2616 14.2466 10.4877 14.2479 10.7175L14.2424 21.9419ZM16.071 17.9991L20.4018 15.4978L24.7325 17.9975V22.9985L20.4018 25.4983L16.071 22.9985V17.9991Z" fill="#10A37F"/></svg>
                Try ChatGPT GPT
              </a>
              <a href="#claude" class="btn-secondary">
                <svg class="btn-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M4.709 15.955l4.72-2.647.08-.23-.08-.128H9.2l-.79-.048-2.698-.073-2.339-.097-2.266-.122-.571-.121L0 11.784l.055-.352.48-.321.686.06 1.52.103 2.278.158 1.652.097 2.449.255h.389l.055-.157-.134-.098-.103-.097-2.358-1.596-2.552-1.688-1.336-.972-.724-.491-.364-.462-.158-1.008.656-.722.881.06.225.061.893.686 1.908 1.476 2.491 1.833.365.304.145-.103.019-.073-.164-.274-1.355-2.446-1.446-2.49-.644-1.032-.17-.619a2.97 2.97 0 01-.104-.729L6.283.134 6.696 0l.996.134.42.364.62 1.414 1.002 2.229 1.555 3.03.456.898.243.832.091.255h.158V9.01l.128-1.706.237-2.095.23-2.695.08-.76.376-.91.747-.492.584.28.48.685-.067.444-.286 1.851-.559 2.903-.364 1.942h.212l.243-.242.985-1.306 1.652-2.064.73-.82.85-.904.547-.431h1.033l.76 1.129-.34 1.166-1.064 1.347-.881 1.142-1.264 1.7-.79 1.36.073.11.188-.02 2.856-.606 1.543-.28 1.841-.315.833.388.091.395-.328.807-1.969.486-2.309.462-3.439.813-.042.03.049.061 1.549.146.662.036h1.622l3.02.225.79.522.474.638-.079.485-1.215.62-1.64-.389-3.829-.91-1.312-.329h-.182v.11l1.093 1.068 2.006 1.81 2.509 2.33.127.578-.322.455-.34-.049-2.205-1.657-.851-.747-1.926-1.62h-.128v.17l.444.649 2.345 3.521.122 1.08-.17.353-.608.213-.668-.122-1.374-1.925-1.415-2.167-1.143-1.943-.14.08-.674 7.254-.316.37-.729.28-.607-.461-.322-.747.322-1.476.389-1.924.315-1.53.286-1.9.17-.632-.012-.042-.14.018-1.434 1.967-2.18 2.945-1.726 1.845-.414.164-.717-.37.067-.662.401-.589 2.388-3.036 1.44-1.882.93-1.086-.006-.158h-.055L4.132 18.56l-1.13.146-.487-.456.061-.746.231-.243 1.908-1.312-.006.006z" fill="currentColor" fill-rule="nonzero"/></svg>
                Setup for Claude
              </a>
            </div>
            <div class="trust-signals">
              <div class="trust-item">
                <strong>55.41%</strong>
                <span>Backtest Win Rate</span>
              </div>
              <div class="trust-item">
                <strong>85</strong>
                <span>Training Symbols</span>
              </div>
              <div class="trust-item">
                <strong v-if="isPremiumUser">150/DAY</strong>
                <strong v-else>FREE</strong>
                <span v-if="isPremiumUser">Premium Predictions</span>
                <span v-else>5 Predictions/Day</span>
              </div>
            </div>
          </div>
          <div class="hero-demo">
            <div class="chat-mockup">
              <div class="chat-header">
                <svg class="chat-avatar" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M37.5324 16.8707C37.9808 15.5241 38.1363 14.0974 37.9886 12.6859C37.8409 11.2744 37.3934 9.91076 36.676 8.68622C35.6126 6.83404 33.9882 5.3676 32.0373 4.4985C30.0864 3.62941 27.9098 3.40259 25.8215 3.85078C24.8796 2.7893 23.7219 1.94125 22.4257 1.36341C21.1295 0.785575 19.7249 0.491269 18.3058 0.500197C16.1708 0.495044 14.0893 1.16803 12.3614 2.42214C10.6335 3.67624 9.34853 5.44666 8.6917 7.47815C7.30085 7.76286 5.98686 8.3414 4.8377 9.17505C3.68854 10.0087 2.73073 11.0782 2.02839 12.312C0.956464 14.1591 0.498905 16.2988 0.721698 18.4228C0.944492 20.5467 1.83612 22.5449 3.268 24.1293C2.81966 25.4759 2.66413 26.9026 2.81182 28.3141C2.95951 29.7256 3.40701 31.0892 4.12437 32.3138C5.18791 34.1659 6.8123 35.6322 8.76321 36.5013C10.7141 37.3704 12.8907 37.5973 14.9789 37.1492C15.9208 38.2107 17.0786 39.0587 18.3747 39.6366C19.6709 40.2144 21.0755 40.5087 22.4946 40.4998C24.6307 40.5054 26.7133 39.8321 28.4418 38.5772C30.1704 37.3223 31.4556 35.5506 32.1119 33.5179C33.5027 33.2332 34.8167 32.6547 35.9659 31.821C37.115 30.9874 38.0728 29.9178 38.7752 28.684C39.8458 26.8371 40.3023 24.6979 40.0789 22.5748C39.8556 20.4517 38.9639 18.4544 37.5324 16.8707ZM22.4978 37.8849C20.7443 37.8874 19.0459 37.2733 17.6994 36.1501C17.7601 36.117 17.8666 36.0586 17.936 36.0161L25.9004 31.4156C26.1003 31.3019 26.2663 31.137 26.3813 30.9378C26.4964 30.7386 26.5563 30.5124 26.5549 30.2825V19.0542L29.9213 20.998C29.9389 21.0068 29.9541 21.0198 29.9656 21.0359C29.977 21.052 29.9842 21.0707 29.9867 21.0902V30.3889C29.9842 32.375 29.1946 34.2791 27.7909 35.6841C26.3872 37.0892 24.4838 37.8806 22.4978 37.8849ZM6.39227 31.0064C5.51397 29.4888 5.19742 27.7107 5.49804 25.9832C5.55718 26.0187 5.66048 26.0818 5.73461 26.1244L13.699 30.7248C13.8975 30.8408 14.1233 30.902 14.3532 30.902C14.583 30.902 14.8088 30.8408 15.0073 30.7248L24.731 25.1103V28.9979C24.7321 29.0177 24.7283 29.0376 24.7199 29.0556C24.7115 29.0736 24.6988 29.0893 24.6829 29.1012L16.6317 33.7497C14.9096 34.7416 12.8643 35.0097 10.9447 34.4954C9.02506 33.9811 7.38785 32.7263 6.39227 31.0064ZM4.29707 13.6194C5.17156 12.0998 6.55279 10.9364 8.19885 10.3327C8.19885 10.4013 8.19491 10.5228 8.19491 10.6071V19.808C8.19351 20.0378 8.25334 20.2638 8.36823 20.4629C8.48312 20.6619 8.64893 20.8267 8.84863 20.9404L18.5723 26.5542L15.206 28.4979C15.1894 28.5089 15.1703 28.5155 15.1505 28.5173C15.1307 28.5191 15.1107 28.516 15.0924 28.5082L7.04046 23.8557C5.32135 22.8601 4.06716 21.2235 3.55289 19.3046C3.03862 17.3858 3.30624 15.3413 4.29707 13.6194ZM31.955 20.0556L22.2312 14.4411L25.5976 12.4981C25.6142 12.4872 25.6333 12.4805 25.6531 12.4787C25.6729 12.4769 25.6928 12.4801 25.7111 12.4879L33.7631 17.1364C34.9967 17.849 36.0017 18.8982 36.6606 20.1613C37.3194 21.4244 37.6047 22.8486 37.4832 24.2632C37.3617 25.6779 36.8382 27.0282 35.9743 28.1596C35.1103 29.291 33.9415 30.1569 32.6047 30.6562C32.6047 30.5875 32.6086 30.4661 32.6086 30.3818V21.188C32.6102 20.9586 32.5506 20.7328 32.4358 20.5338C32.321 20.3348 32.155 20.1698 31.955 20.0556ZM35.3055 15.0128C35.2464 14.9765 35.1431 14.9142 35.069 14.8717L27.1045 10.2712C26.906 10.1554 26.6802 10.0943 26.4504 10.0943C26.2206 10.0943 25.9948 10.1554 25.7963 10.2712L16.0726 15.8858V11.9982C16.0715 11.9783 16.0753 11.9585 16.0837 11.9405C16.0921 11.9225 16.1048 11.9068 16.1207 11.8949L24.1719 7.25025C25.4053 6.53903 26.8158 6.19376 28.2383 6.25482C29.6608 6.31589 31.0364 6.78077 32.2044 7.59508C33.3723 8.40939 34.2842 9.53945 34.8334 10.8531C35.3826 12.1667 35.5464 13.6095 35.3055 15.0128ZM14.2424 21.9419L10.8752 19.9981C10.8576 19.9893 10.8423 19.9763 10.8309 19.9602C10.8195 19.9441 10.8122 19.9254 10.8098 19.9058V10.6071C10.8107 9.18295 11.2173 7.78848 11.9819 6.58696C12.7466 5.38544 13.8377 4.42659 15.1275 3.82264C16.4173 3.21869 17.8524 2.99464 19.2649 3.1767C20.6775 3.35876 22.0089 3.93941 23.1034 4.85067C23.0427 4.88379 22.937 4.94215 22.8668 4.98473L14.9024 9.58517C14.7025 9.69878 14.5366 9.86356 14.4215 10.0626C14.3065 10.2616 14.2466 10.4877 14.2479 10.7175L14.2424 21.9419ZM16.071 17.9991L20.4018 15.4978L24.7325 17.9975V22.9985L20.4018 25.4983L16.071 22.9985V17.9991Z" fill="#10A37F"/></svg>
                <span>ChatGPT</span>
              </div>
              <div class="chat-message user">
                What's your 10-day prediction for AAPL?
              </div>
              <div class="chat-message assistant">
                <div class="thinking">Using InvestBuddy AI...</div>
                <div class="prediction-card">
                  <div class="prediction-header">
                    <strong>AAPL</strong>
                    <span class="bullish">📈 Bullish</span>
                  </div>
                  <div class="prediction-data">
                    <div class="price">
                      <span class="label">Current:</span>
                      <span class="value">$182.45</span>
                    </div>
                    <div class="price">
                      <span class="label">Predicted:</span>
                      <span class="value predicted">$189.20</span>
                    </div>
                  </div>
                  <div class="confidence-bar">
                    <div class="bar" style="width: 85%"></div>
                    <span>85% Confidence</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- How It Works -->
    <section class="how-it-works">
      <div class="container">
        <h2>How It Works</h2>
        <p class="section-subtitle">Get started in 30 seconds</p>
        
        <div class="steps">
          <div class="step">
            <div class="step-number">1</div>
            <h3>Open ChatGPT/Claude</h3>
            <p>Visit the ChatGPT GPT link (no login required for guests) or configure Claude Desktop</p>
          </div>
          <div class="step-arrow">→</div>
          <div class="step">
            <div class="step-number">2</div>
            <h3>Connect API (Optional)</h3>
            <p>Get your free API key for unlimited access via Claude Desktop or authenticated ChatGPT</p>
          </div>
          <div class="step-arrow">→</div>
          <div class="step">
            <div class="step-number">3</div>
            <h3>Start Asking</h3>
            <p>Chat naturally about stocks, portfolios, and market trends</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Prompt Library CTA -->
    <section class="prompt-library-cta">
      <div class="container">
        <div class="cta-card">
          <div class="cta-badge">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" viewBox="0 0 20 20" fill="currentColor">
              <path d="M9 4.804A7.968 7.968 0 005.5 4c-1.255 0-2.443.29-3.5.804v10A7.969 7.969 0 015.5 14c1.669 0 3.218.51 4.5 1.385A7.962 7.962 0 0114.5 14c1.255 0 2.443.29 3.5.804v-10A7.968 7.968 0 0014.5 4c-1.255 0-2.443.29-3.5.804V12a1 1 0 11-2 0V4.804z" />
            </svg>
            <span>NEW</span>
          </div>
          <h2>Daily Copilot Workflows</h2>
          <p class="cta-description">
            Learn the "Core & Explore" methodology: How to use InvestBuddy every day
            while maintaining your optimal monthly rebalance strategy (+63.41% alpha).
          </p>
          <div class="cta-features">
            <div class="feature">
              <div class="feature-icon">🛡️</div>
              <div class="feature-text">
                <strong>Daily Risk Manager</strong>
                <span>Morning pulse checks & hedging strategies</span>
              </div>
            </div>
            <div class="feature">
              <div class="feature-icon">🔭</div>
              <div class="feature-text">
                <strong>Swing Trade Sniper</strong>
                <span>5-10 day momentum plays for active capital</span>
              </div>
            </div>
            <div class="feature">
              <div class="feature-icon">⚖️</div>
              <div class="feature-text">
                <strong>Earnings Validator</strong>
                <span>Strip emotion from news-driven volatility</span>
              </div>
            </div>
            <div class="feature">
              <div class="feature-icon">🧮</div>
              <div class="feature-text">
                <strong>401(k) Optimizer</strong>
                <span>Holistic portfolio health checks</span>
              </div>
            </div>
          </div>
          <RouterLink to="/prompts" class="cta-button">
            View Full Prompt Library →
          </RouterLink>
        </div>
      </div>
    </section>

    <!-- Example Prompts -->
    <section class="example-prompts">
      <div class="container">
        <h2>Example Prompts</h2>
        <p class="section-subtitle">Try these questions in ChatGPT or Claude</p>
        
        <div class="prompts-grid">
          <div class="prompt-card" v-for="prompt in examplePrompts" :key="prompt.title">
            <div class="prompt-icon">{{ prompt.icon }}</div>
            <h4>{{ prompt.title }}</h4>
            <p class="prompt-text">"{{ prompt.text }}"</p>
            <span class="prompt-category">{{ prompt.category }}</span>
          </div>
        </div>
      </div>
    </section>

    <!-- Setup Guides -->
    <section id="chatgpt" class="setup-section chatgpt-section">
      <div class="container">
        <!-- Status Ribbon -->
        <div class="coming-soon-ribbon" style="background: linear-gradient(135deg, #10b981 0%, #059669 100%);">
          <svg style="width: 24px; height: 24px; flex-shrink: 0;" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M37.5324 16.8707C37.9808 15.5241 38.1363 14.0974 37.9886 12.6859C37.8409 11.2744 37.3934 9.91076 36.676 8.68622C35.6126 6.83404 33.9882 5.3676 32.0373 4.4985C30.0864 3.62941 27.9098 3.40259 25.8215 3.85078C24.8796 2.7893 23.7219 1.94125 22.4257 1.36341C21.1295 0.785575 19.7249 0.491269 18.3058 0.500197C16.1708 0.495044 14.0893 1.16803 12.3614 2.42214C10.6335 3.67624 9.34853 5.44666 8.6917 7.47815C7.30085 7.76286 5.98686 8.3414 4.8377 9.17505C3.68854 10.0087 2.73073 11.0782 2.02839 12.312C0.956464 14.1591 0.498905 16.2988 0.721698 18.4228C0.944492 20.5467 1.83612 22.5449 3.268 24.1293C2.81966 25.4759 2.66413 26.9026 2.81182 28.3141C2.95951 29.7256 3.40701 31.0892 4.12437 32.3138C5.18791 34.1659 6.8123 35.6322 8.76321 36.5013C10.7141 37.3704 12.8907 37.5973 14.9789 37.1492C15.9208 38.2107 17.0786 39.0587 18.3747 39.6366C19.6709 40.2144 21.0755 40.5087 22.4946 40.4998C24.6307 40.5054 26.7133 39.8321 28.4418 38.5772C30.1704 37.3223 31.4556 35.5506 32.1119 33.5179C33.5027 33.2332 34.8167 32.6547 35.9659 31.821C37.115 30.9874 38.0728 29.9178 38.7752 28.684C39.8458 26.8371 40.3023 24.6979 40.0789 22.5748C39.8556 20.4517 38.9639 18.4544 37.5324 16.8707ZM22.4978 37.8849C20.7443 37.8874 19.0459 37.2733 17.6994 36.1501C17.7601 36.117 17.8666 36.0586 17.936 36.0161L25.9004 31.4156C26.1003 31.3019 26.2663 31.137 26.3813 30.9378C26.4964 30.7386 26.5563 30.5124 26.5549 30.2825V19.0542L29.9213 20.998C29.9389 21.0068 29.9541 21.0198 29.9656 21.0359C29.977 21.052 29.9842 21.0707 29.9867 21.0902V30.3889C29.9842 32.375 29.1946 34.2791 27.7909 35.6841C26.3872 37.0892 24.4838 37.8806 22.4978 37.8849ZM6.39227 31.0064C5.51397 29.4888 5.19742 27.7107 5.49804 25.9832C5.55718 26.0187 5.66048 26.0818 5.73461 26.1244L13.699 30.7248C13.8975 30.8408 14.1233 30.902 14.3532 30.902C14.583 30.902 14.8088 30.8408 15.0073 30.7248L24.731 25.1103V28.9979C24.7321 29.0177 24.7283 29.0376 24.7199 29.0556C24.7115 29.0736 24.6988 29.0893 24.6829 29.1012L16.6317 33.7497C14.9096 34.7416 12.8643 35.0097 10.9447 34.4954C9.02506 33.9811 7.38785 32.7263 6.39227 31.0064ZM4.29707 13.6194C5.17156 12.0998 6.55279 10.9364 8.19885 10.3327C8.19885 10.4013 8.19491 10.5228 8.19491 10.6071V19.808C8.19351 20.0378 8.25334 20.2638 8.36823 20.4629C8.48312 20.6619 8.64893 20.8267 8.84863 20.9404L18.5723 26.5542L15.206 28.4979C15.1894 28.5089 15.1703 28.5155 15.1505 28.5173C15.1307 28.5191 15.1107 28.516 15.0924 28.5082L7.04046 23.8557C5.32135 22.8601 4.06716 21.2235 3.55289 19.3046C3.03862 17.3858 3.30624 15.3413 4.29707 13.6194ZM31.955 20.0556L22.2312 14.4411L25.5976 12.4981C25.6142 12.4872 25.6333 12.4805 25.6531 12.4787C25.6729 12.4769 25.6928 12.4801 25.7111 12.4879L33.7631 17.1364C34.9967 17.849 36.0017 18.8982 36.6606 20.1613C37.3194 21.4244 37.6047 22.8486 37.4832 24.2632C37.3617 25.6779 36.8382 27.0282 35.9743 28.1596C35.1103 29.291 33.9415 30.1569 32.6047 30.6562C32.6047 30.5875 32.6086 30.4661 32.6086 30.3818V21.188C32.6102 20.9586 32.5506 20.7328 32.4358 20.5338C32.321 20.3348 32.155 20.1698 31.955 20.0556ZM35.3055 15.0128C35.2464 14.9765 35.1431 14.9142 35.069 14.8717L27.1045 10.2712C26.906 10.1554 26.6802 10.0943 26.4504 10.0943C26.2206 10.0943 25.9948 10.1554 25.7963 10.2712L16.0726 15.8858V11.9982C16.0715 11.9783 16.0753 11.9585 16.0837 11.9405C16.0921 11.9225 16.1048 11.9068 16.1207 11.8949L24.1719 7.25025C25.4053 6.53903 26.8158 6.19376 28.2383 6.25482C29.6608 6.31589 31.0364 6.78077 32.2044 7.59508C33.3723 8.40939 34.2842 9.53945 34.8334 10.8531C35.3826 12.1667 35.5464 13.6095 35.3055 15.0128ZM14.2424 21.9419L10.8752 19.9981C10.8576 19.9893 10.8423 19.9763 10.8309 19.9602C10.8195 19.9441 10.8122 19.9254 10.8098 19.9058V10.6071C10.8107 9.18295 11.2173 7.78848 11.9819 6.58696C12.7466 5.38544 13.8377 4.42659 15.1275 3.82264C16.4173 3.21869 17.8524 2.99464 19.2649 3.1767C20.6775 3.35876 22.0089 3.93941 23.1034 4.85067C23.0427 4.88379 22.937 4.94215 22.8668 4.98473L14.9024 9.58517C14.7025 9.69878 14.5366 9.86356 14.4215 10.0626C14.3065 10.2616 14.2466 10.4877 14.2479 10.7175L14.2424 21.9419ZM16.071 17.9991L20.4018 15.4978L24.7325 17.9975V22.9985L20.4018 25.4983L16.071 22.9985V17.9991Z" fill="#10A37F"/></svg>
          <span class="ribbon-text">ChatGPT GPT Live Now!</span>
        </div>
        <div class="setup-content">
          <div class="setup-text">
            <h2>ChatGPT GPT - Available Now! 🎉</h2>
            <p>Try InvestBuddy directly in ChatGPT - no API key needed for guests</p>
            
            <div class="setup-note" style="margin-bottom: 1.5rem; background: #10b981; border-left-color: #059669;">
              <span class="icon">🎁</span>
              <div>
                <strong>Guest Access:</strong> Try up to 20 predictions/day without logging in! <strong style="background: rgba(255,255,255,0.2); padding: 0.15rem 0.4rem; border-radius: 4px;">Limited Offer</strong>
                <a href="https://chatgpt.com/g/g-694af6f8140c8191a54120429141228f-investbuddy-ai-stock-forecasts" target="_blank" rel="noopener" style="color: white; text-decoration: underline; margin-left: 0.5rem;">Open ChatGPT GPT →</a>
              </div>
            </div>
            
            <ol class="setup-steps">
              <li>
                <strong>Open the ChatGPT GPT</strong>
                <p>
                  <a href="https://chatgpt.com/g/g-694af6f8140c8191a54120429141228f-investbuddy-ai-stock-forecasts" target="_blank" rel="noopener" class="inline-link">
                    Visit InvestBuddy GPT →
                  </a>
                </p>
              </li>
              <li>
                <strong>Start Asking Questions</strong>
                <p>No setup required! Just ask about any stock prediction</p>
              </li>
              <li>
                <strong>Get 20 Free Predictions/Day</strong> <span style="background: #fbbf24; color: #78350f; padding: 0.15rem 0.5rem; border-radius: 4px; font-size: 0.75rem; font-weight: 700; margin-left: 0.5rem;">LIMITED OFFER</span>
                <p>Guest users get 20 predictions per day (resets at midnight UTC) - limited time only!</p>
              </li>
              <li>
                <strong>Want Unlimited? (Optional)</strong>
                <p>
                  <router-link to="/register" class="inline-link">Create an account</router-link> 
                  for 150/day with FOUNDERS2026
                </p>
              </li>
            </ol>

            <div class="setup-note">
              <span class="icon">ℹ️</span>
              <div>
                <strong>Note:</strong> Must be logged into ChatGPT to use the GPT. 
                Guest predictions don't require InvestBuddy registration.
              </div>
            </div>
          </div>
          <div class="setup-visual">
            <div class="placeholder-screenshot">
              <div class="placeholder-content">
                <img src="/InvestBuddyLogo.png" alt="InvestBuddy" class="placeholder-logo" />
                <h4>InvestBuddy AI GPT</h4>
                <p>10+ investors already using</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="claude" class="setup-section claude-section">
      <div class="container">
        <div class="setup-content reverse">
          <div class="setup-visual">
            <div class="code-example">
              <div class="code-header">
                <span>claude_desktop_config.json</span>
                <button @click="copyConfig" class="btn-copy">
                  {{ configCopied ? '✓ Copied' : '📋 Copy' }}
                </button>
              </div>
              <pre><code>{{`{
  "mcpServers": {
    "investbuddy": {
      "command": "npx",
      "args": [
        "-y",
        "@investbuddy/mcp-server"
      ],
      "env": {
        "INVESTBUDDY_API_KEY": "YOUR_API_KEY_HERE"
      }
    }
  }
}`}}</code></pre>
            </div>
          </div>
          <div class="setup-text">
            <h2>Claude Desktop Setup</h2>
            <p>Add InvestBuddy as an MCP server</p>
            
            <div class="setup-note" style="margin-bottom: 1.5rem; background: #3b82f6; border-left-color: #1d4ed8;">
              <span class="icon">ℹ️</span>
              <div>
                <strong>Requires Claude Desktop:</strong> MCP integration only works in the Claude Desktop app, not the web version (claude.ai).
                <a href="https://claude.ai/download" target="_blank" style="color: white; text-decoration: underline; margin-left: 0.5rem;">Download Claude Desktop →</a>
              </div>
            </div>
            
            <ol class="setup-steps">
              <li>
                <strong>Get Your API Key</strong>
                <p>
                  <router-link to="/settings/api-keys" class="inline-link">
                    Generate a free API key →
                  </router-link>
                </p>
              </li>
              <li>
                <strong>Open Claude Config</strong>
                <p>Settings (⌘,) → Developer → Edit Config</p>
              </li>
              <li>
                <strong>Add MCP Server</strong>
                <p>Copy the config and paste your API key</p>
              </li>
              <li>
                <strong>Restart Claude</strong>
                <p>Restart Claude Desktop to activate the server</p>
              </li>
            </ol>

            <div class="setup-note">
              <span class="icon">📚</span>
              <div>
                <strong>Need Help?</strong> See the setup instructions above or 
                <router-link to="/settings/api-keys" class="inline-link">manage your API keys</router-link>.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Pricing (only show to non-premium users) -->
    <section v-if="!isPremiumUser" class="pricing-section">
      <div class="container">
        <h2>Simple, Transparent Pricing</h2>
        <p class="section-subtitle">Pay only for what you use</p>
        
        <div class="pricing-grid">
          <div class="pricing-card">
            <h3>Free</h3>
            <div class="price">
              <span class="amount">$0</span>
              <span class="period">/month</span>
            </div>
            <ul class="features">
              <li>✓ 5 predictions per day</li>
              <li>✓ 55.41% backtest win rate</li>
              <li>✓ ChatGPT & Claude</li>
              <li>✓ Resets daily at midnight</li>
            </ul>
            <router-link to="/register" class="btn-pricing">Get Started</router-link>
          </div>

          <div class="pricing-card featured">
            <div class="badge">Most Popular</div>
            <h3>Premium</h3>
            <div class="price">
              <span class="amount-strike">$39</span>
              <span class="amount">$19</span>
              <span class="period">/month</span>
            </div>
            <div class="founders-badge">🔒 Locked for life • Use FOUNDERS2026</div>
            <ul class="features">
              <li>✓ 150 API predictions per day</li>
              <li>✓ Full web platform access</li>
              <li>✓ All 5 MCP tools</li>
              <li>✓ Stock discovery AI</li>
              <li>✓ Portfolio analysis</li>
              <li>✓ Batch predictions</li>
            </ul>
            <router-link to="/pricing" class="btn-pricing primary">Get Premium Now</router-link>
          </div>

          <div class="pricing-card">
            <h3>Enterprise</h3>
            <div class="price">
              <span class="amount">Custom</span>
              <span class="period">pricing</span>
            </div>
            <ul class="features">
              <li>✓ Unlimited API predictions</li>
              <li>✓ Advanced analytics</li>
              <li>✓ Custom webhooks</li>
              <li>✓ Dedicated support</li>
              <li>✓ Team collaboration</li>
            </ul>
            <a href="mailto:support@investbuddy.ai?subject=Enterprise%20API%20Access%20Inquiry&body=Hi%20InvestBuddy%20team%2C%0A%0AI'm%20interested%20in%20Enterprise%20API%20access.%0A%0ACompany%3A%20%0AUse%20Case%3A%20%0AEstimated%20Monthly%20API%20Calls%3A%20%0A%0APlease%20contact%20me%20at%3A%0AName%3A%20%0AEmail%3A%20%0APhone%3A%20%0A%0AThank%20you!" class="btn-pricing">Contact Sales</a>
          </div>
        </div>
      </div>
    </section>

    <!-- FAQ -->
    <section class="faq-section">
      <div class="container">
        <h2>Frequently Asked Questions</h2>
        
        <div class="faq-list">
          <div 
            v-for="(faq, index) in faqs" 
            :key="index"
            class="faq-item"
            :class="{ open: openFaq === index }"
            @click="openFaq = openFaq === index ? null : index"
          >
            <div class="faq-question">
              <h4>{{ faq.question }}</h4>
              <span class="faq-toggle">{{ openFaq === index ? '−' : '+' }}</span>
            </div>
            <div v-if="openFaq === index" class="faq-answer">
              <p>{{ faq.answer }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- CTA Section -->
    <section class="final-cta">
      <div class="container">
        <h2>Ready to Get Started?</h2>
        <p>Join thousands using AI-powered stock predictions in ChatGPT and Claude</p>
        <div class="cta-buttons">
          <a href="#chatgpt" class="btn-primary">Install for ChatGPT</a>
          <router-link to="/settings/api-keys" class="btn-secondary">Get API Key</router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed } from 'vue'
import { useAuthStore } from '@/stores/auth'

const authStore = useAuthStore()

const configCopied = ref(false)
const openFaq = ref<number | null>(null)

// Check if user is premium (active subscription)
const isPremiumUser = computed(() => {
  const user = authStore.user
  return user?.subscriptionPlan === 'premium' && user?.subscriptionStatus === 'active'
})

// Handle smooth scroll on mount if hash is present
onMounted(() => {
  if (window.location.hash === '#setup') {
    const claudeSection = document.getElementById('claude')
    if (claudeSection) {
      setTimeout(() => {
        claudeSection.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }, 100)
    }
  }
})

const examplePrompts = [
  {
    icon: '📊',
    title: 'Stock Prediction',
    text: 'What\'s your 10-day prediction for TSLA?',
    category: 'Single Stock'
  },
  {
    icon: '🎯',
    title: 'Portfolio Analysis',
    text: 'Analyze my portfolio: 50 shares AAPL, 30 shares MSFT, 100 shares NVDA',
    category: 'Portfolio'
  },
  {
    icon: '🔍',
    title: 'Stock Discovery',
    text: 'Find me 5 high-confidence bullish stocks in tech',
    category: 'Discovery'
  },
  {
    icon: '📈',
    title: 'Market Regime',
    text: 'Is the market bullish or bearish right now?',
    category: 'Market Analysis'
  },
  {
    icon: '⚖️',
    title: 'Comparison',
    text: 'Compare predictions for AAPL vs GOOGL vs MSFT',
    category: 'Comparison'
  },
  {
    icon: '🎲',
    title: 'Risk Assessment',
    text: 'What\'s the risk level of holding TSLA for 10 days?',
    category: 'Risk'
  }
]

const faqs = [
  {
    question: 'How accurate are the predictions?',
    answer: 'Our LSTM model has been validated with 55.41% OOS win rate in real backtesting (241 trades, 2022-2025, monthly rebalancing). Trained on 77 symbols (13,014 sequences), validated out-of-sample on 85 — including 8 unseen semiconductors the model generalized to without retraining. Past performance doesn\'t guarantee future results. Always do your own research.'
  },
  {
    question: 'Is this financial advice?',
    answer: 'No. InvestBuddy provides AI-powered predictions and analysis for informational purposes only. This is not financial advice. Consult with a licensed financial advisor before making investment decisions.'
  },
  {
    question: 'How is this different from using ChatGPT alone?',
    answer: 'ChatGPT doesn\'t have real-time stock data or predictive models. InvestBuddy adds our validated LSTM AI that analyzes historical patterns, technical indicators, and market conditions to generate data-driven predictions.'
  },
  {
    question: 'Can I use this in both ChatGPT and Claude?',
    answer: 'Yes! ChatGPT has a live GPT you can try as a guest (20 predictions/day - limited launch offer). For Claude Desktop, you need to configure the MCP server with your API key from Settings.'
  },
  {
    question: 'What happens if I hit my rate limit?',
    answer: 'Guest users (ChatGPT GPT without login) get 20 predictions/day during our Q1 launch offer. Registered free users get 5/day via API. When you hit your limit, wait until midnight UTC for reset, or upgrade to Premium (150/day) with code FOUNDERS2026 for $19/month early adopter rate (locked forever, public launch at $39/mo).'
  },
  {
    question: 'Do predictions work for any stock?',
    answer: 'Our model is trained on S&P 500 stocks and works best with large-cap, liquid stocks. Predictions for small-cap or low-volume stocks may be less reliable.'
  },
  {
    question: 'How often is the model updated?',
    answer: 'Our LSTM model retrains daily with the latest market data to ensure predictions reflect current market conditions and patterns.'
  },
  {
    question: 'Can I cancel anytime?',
    answer: 'Yes. All paid plans are monthly subscriptions with no long-term commitment. Cancel anytime from your account settings.'
  }
]

function copyConfig() {
  const config = `{
  "mcpServers": {
    "investbuddy": {
      "command": "npx",
      "args": ["-y", "@investbuddy/mcp-server"],
      "env": {
        "INVESTBUDDY_API_KEY": "YOUR_API_KEY_HERE"
      }
    }
  }
}`
  navigator.clipboard.writeText(config)
  configCopied.value = true
  setTimeout(() => configCopied.value = false, 2000)
}

function scrollToClaude() {
  const claudeSection = document.getElementById('claude')
  if (claudeSection) {
    claudeSection.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }
}

function scrollToSetup() {
  const setupSection = document.getElementById('claude') // Reuse Claude setup section for premium users
  if (setupSection) {
    setupSection.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }
}
</script>

<style scoped>
.mcp-landing {
  background: white;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

/* Q1 Launch Promo Banner */
.beta-promo-banner {
  background: linear-gradient(135deg, #1e3a8a 0%, #059669 100%);
  color: white;
  padding: 1.25rem 0;
  position: sticky;
  top: 0;
  z-index: 1000;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  animation: slideDown 0.5s ease-out;
}

@keyframes slideDown {
  from {
    transform: translateY(-100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.premium-welcome-banner {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 1.25rem 0;
  position: sticky;
  top: 0;
  z-index: 1000;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  animation: slideDown 0.5s ease-out;
}

.promo-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1.5rem;
  flex-wrap: wrap;
}

.premium-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1.5rem;
  flex-wrap: wrap;
}

.promo-badge {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.premium-badge {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.beta-tag {
  background: rgba(255, 255, 255, 0.25);
  padding: 0.4rem 0.9rem;
  border-radius: 999px;
  font-size: 0.85rem;
  font-weight: 700;
  letter-spacing: 0.5px;
  animation: pulse 2s infinite;
}

.premium-tag {
  background: rgba(255, 255, 255, 0.25);
  padding: 0.4rem 0.9rem;
  border-radius: 999px;
  font-size: 0.85rem;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.promo-text {
  font-size: 1rem;
  font-weight: 500;
}

.premium-text {
  font-size: 1rem;
  font-weight: 500;
}

.promo-text strong {
  font-weight: 800;
  text-decoration: underline;
  text-decoration-thickness: 2px;
  text-underline-offset: 2px;
}

.promo-cta {
  background: white;
  color: #d97706;
  padding: 0.65rem 1.75rem;
  border-radius: 999px;
  font-weight: 700;
  text-decoration: none;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.promo-cta:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
}

.premium-cta {
  background: white;
  color: #667eea;
  padding: 0.65rem 1.75rem;
  border-radius: 999px;
  font-weight: 700;
  text-decoration: none;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.premium-cta:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
}

@media (max-width: 768px) {
  .promo-content {
    flex-direction: column;
    text-align: center;
  }
  
  .promo-badge {
    flex-direction: column;
    gap: 0.5rem;
  }
}

/* Hero Section */
.hero {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 6rem 0;
  position: relative;
  overflow: hidden;
}

.hero-badge {
  text-align: center;
  margin-bottom: 2rem;
}

.hero-logo {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

/* Status Banner */
.status-banner {
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin-bottom: 3rem;
  flex-wrap: wrap;
}

.status-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background: rgba(255, 255, 255, 0.15);
  padding: 0.75rem 1.5rem;
  border-radius: 999px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.status-logo {
  width: 24px;
  height: 24px;
  border-radius: 6px;
  flex-shrink: 0;
}

.status-item.available .status-logo {
  box-shadow: 0 0 10px rgba(72, 187, 120, 0.5);
}

.status-text {
  font-size: 0.875rem;
  color: white;
}

.status-text strong {
  font-weight: 700;
}

.hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120"><path d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z" opacity=".25" fill="white"></path></svg>') bottom center no-repeat;
  background-size: cover;
  opacity: 0.1;
}

.hero-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;
  position: relative;
  z-index: 1;
}

.hero h1 {
  font-size: 3.5rem;
  font-weight: 800;
  line-height: 1.1;
  margin: 0 0 1.5rem 0;
}

.gradient-text {
  background: linear-gradient(135deg, #ffd89b 0%, #19547b 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.subtitle {
  font-size: 1.25rem;
  opacity: 0.95;
  margin-bottom: 2rem;
  line-height: 1.6;
}

.cta-buttons {
  display: flex;
  gap: 1rem;
  margin-bottom: 3rem;
}

.btn-primary, .btn-secondary {
  padding: 1rem 2rem;
  border-radius: 12px;
  font-weight: 600;
  font-size: 1.125rem;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  transition: all 0.3s;
}

.btn-icon {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  flex-shrink: 0;
  object-fit: contain;
}

.btn-primary {
  background: white;
  color: #667eea;
  box-shadow: 0 4px 14px rgba(0,0,0,0.1);
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0,0,0,0.15);
}

.btn-secondary {
  background: rgba(255,255,255,0.2);
  color: white;
  border: 2px solid rgba(255,255,255,0.5);
}

.btn-secondary:hover {
  background: rgba(255,255,255,0.3);
}

.btn-secondary svg {
  fill: white;
}

.trust-signals {
  display: flex;
  gap: 3rem;
}

.trust-item {
  display: flex;
  flex-direction: column;
}

.trust-item strong {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 0.25rem;
}

.trust-item span {
  font-size: 0.875rem;
  opacity: 0.9;
}

/* Chat Mockup */
.chat-mockup {
  background: white;
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 20px 60px rgba(0,0,0,0.3);
}

.chat-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e2e8f0;
}

.chat-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.chat-header span {
  font-weight: 600;
  color: #2d3748;
}

.chat-message {
  margin-bottom: 1rem;
  padding: 1rem;
  border-radius: 12px;
  color: #2d3748;
}

.chat-message.user {
  background: #f7fafc;
  margin-left: 2rem;
}

.chat-message.assistant {
  background: #ebf8ff;
  margin-right: 2rem;
}

.thinking {
  font-size: 0.875rem;
  color: #718096;
  font-style: italic;
  margin-bottom: 0.75rem;
}

.prediction-card {
  background: white;
  padding: 1rem;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.prediction-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
}

.bullish {
  background: #c6f6d5;
  color: #22543d;
  padding: 0.25rem 0.75rem;
  border-radius: 999px;
  font-size: 0.875rem;
  font-weight: 600;
}

.prediction-data {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-bottom: 1rem;
}

.price {
  display: flex;
  flex-direction: column;
}

.price .label {
  font-size: 0.75rem;
  color: #718096;
  margin-bottom: 0.25rem;
}

.price .value {
  font-size: 1.25rem;
  font-weight: 700;
  color: #2d3748;
}

.price .predicted {
  color: #48bb78;
}

.confidence-bar {
  position: relative;
  background: #e2e8f0;
  height: 8px;
  border-radius: 999px;
  overflow: hidden;
}

.confidence-bar .bar {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: linear-gradient(90deg, #48bb78, #38a169);
}

.confidence-bar span {
  position: absolute;
  right: 0.5rem;
  top: -1.5rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: #48bb78;
}

/* How It Works */
.how-it-works {
  padding: 6rem 0;
  background: #f7fafc;
}

.how-it-works h2 {
  text-align: center;
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  color: #1a202c;
}

.section-subtitle {
  text-align: center;
  font-size: 1.125rem;
  color: #718096;
  margin-bottom: 4rem;
}

.steps {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;
}

.step {
  flex: 1;
  max-width: 300px;
  text-align: center;
  position: relative;
  padding: 3rem 2rem 2rem;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
}

.step-number {
  position: absolute;
  top: -16px;
  left: 50%;
  transform: translateX(-50%);
  width: 40px;
  height: 40px;
  background: #667eea;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 1.125rem;
  z-index: 1;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.step-icon {
  font-size: 4rem;
  margin-bottom: 1rem;
  min-height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.brand-combo {
  display: flex;
  align-items: center;
  gap: 8px;
}

.step h3 {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #2d3748;
}

.step p {
  color: #718096;
  font-size: 0.9375rem;
}

.step-arrow {
  font-size: 2rem;
  color: #cbd5e0;
  flex-shrink: 0;
}

/* Example Prompts */
.example-prompts {
  padding: 6rem 0;
}

.example-prompts h2 {
  text-align: center;
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  color: #1a202c;
}

.prompts-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
  margin-top: 3rem;
}

.prompt-card {
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  padding: 2rem;
  transition: all 0.3s;
  cursor: pointer;
}

.prompt-card:hover {
  border-color: #667eea;
  transform: translateY(-4px);
  box-shadow: 0 10px 30px rgba(102, 126, 234, 0.1);
}

.prompt-icon {
  font-size: 2.5rem;
  margin-bottom: 1rem;
}

.prompt-card h4 {
  font-size: 1.125rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
  color: #2d3748;
}

.prompt-text {
  color: #4a5568;
  font-style: italic;
  margin-bottom: 1rem;
  line-height: 1.5;
}

.prompt-category {
  display: inline-block;
  background: #edf2f7;
  color: #4a5568;
  padding: 0.25rem 0.75rem;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
}

/* Setup Sections */
.setup-section {
  padding: 6rem 0;
}

/* Coming Soon Ribbon */
.coming-soon-ribbon {
  background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);
  color: #1f2937;
  padding: 1rem 2rem;
  text-align: center;
  font-weight: 700;
  font-size: 1rem;
  margin-bottom: 3rem;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(251, 191, 36, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
}

.ribbon-icon {
  font-size: 1.5rem;
  animation: float 2s ease-in-out infinite;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}

.ribbon-text {
  font-size: 1rem;
}

.chatgpt-section {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.claude-section {
  background: #1a202c;
  color: white;
}

.setup-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;
}

.setup-content.reverse {
  grid-template-columns: 1fr 1fr;
}

.setup-text h2 {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
}

.setup-text > p {
  font-size: 1.125rem;
  opacity: 0.9;
  margin-bottom: 2rem;
}

.setup-steps {
  list-style: none;
  padding: 0;
  margin: 0 0 2rem 0;
}

.setup-steps li {
  margin-bottom: 1.5rem;
  padding-left: 2rem;
  position: relative;
}

.setup-steps li::before {
  content: '→';
  position: absolute;
  left: 0;
  font-weight: 700;
  color: rgba(255,255,255,0.7);
}

.setup-steps strong {
  display: block;
  font-size: 1.125rem;
  margin-bottom: 0.25rem;
}

.setup-steps p {
  opacity: 0.9;
  margin: 0;
}

.setup-note {
  background: rgba(255,255,255,0.1);
  border: 2px solid rgba(255,255,255,0.2);
  border-radius: 12px;
  padding: 1.5rem;
  display: flex;
  gap: 1rem;
}

.setup-note .icon {
  font-size: 1.5rem;
  flex-shrink: 0;
}

.inline-link {
  color: white;
  font-weight: 600;
  text-decoration: underline;
  text-decoration-thickness: 2px;
  text-underline-offset: 2px;
}

.inline-link:hover {
  opacity: 0.8;
}

.screenshot {
  width: 100%;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0,0,0,0.3);
}

.code-example {
  background: #0d1117;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0,0,0,0.5);
}

.code-header {
  background: #161b22;
  padding: 1rem 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #30363d;
}

.code-header span {
  font-family: 'Monaco', 'Courier New', monospace;
  font-size: 0.875rem;
  color: #8b949e;
}

.btn-copy {
  background: #238636;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 600;
}

.btn-copy:hover {
  background: #2ea043;
}

.code-example pre {
  margin: 0;
  padding: 1.5rem;
  overflow-x: auto;
}

.code-example code {
  font-family: 'Monaco', 'Courier New', monospace;
  font-size: 0.875rem;
  line-height: 1.6;
  color: #c9d1d9;
}

.placeholder-screenshot {
  background: linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%);
  border: 3px dashed #cbd5e0;
  border-radius: 12px;
  padding: 4rem 2rem;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0,0,0,0.1);
}

.placeholder-content {
  max-width: 400px;
  margin: 0 auto;
}

.placeholder-icon {
  font-size: 5rem;
  margin-bottom: 1.5rem;
}

.placeholder-logo {
  width: 120px;
  height: 120px;
  margin-bottom: 1.5rem;
  border-radius: 50%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.placeholder-screenshot h4 {
  font-size: 1.5rem;
  font-weight: 700;
  color: #2d3748;
  margin-bottom: 0.5rem;
}

.placeholder-screenshot p {
  font-size: 1.125rem;
  color: #718096;
}

/* Pricing */
.pricing-section {
  padding: 6rem 0;
  background: #f7fafc;
}

.pricing-section h2 {
  text-align: center;
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  color: #1a202c;
}

.pricing-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  margin-top: 3rem;
}

.pricing-card {
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 16px;
  padding: 2.5rem;
  position: relative;
  transition: all 0.3s;
}

.pricing-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 40px rgba(0,0,0,0.1);
}

.pricing-card.featured {
  border-color: #667eea;
  border-width: 3px;
}

.badge {
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  background: #667eea;
  color: white;
  padding: 0.375rem 1rem;
  border-radius: 999px;
  font-size: 0.875rem;
  font-weight: 600;
}

.pricing-card h3 {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
  color: #2d3748;
  text-align: center;
}

.price {
  text-align: center;
  margin-bottom: 2rem;
}

.price .amount-strike {
  font-size: 1.5rem;
  font-weight: 600;
  color: #cbd5e0;
  text-decoration: line-through;
  display: block;
  margin-bottom: 0.5rem;
}

.price .amount {
  font-size: 3rem;
  font-weight: 800;
  color: #2d3748;
}

.price .period {
  font-size: 1rem;
  color: #718096;
}

.founders-badge {
  text-align: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 999px;
  font-size: 0.875rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  display: inline-block;
  width: 100%;
}

.features {
  list-style: none;
  padding: 0;
  margin: 0 0 2rem 0;
}

.features li {
  padding: 0.75rem 0;
  color: #4a5568;
  border-bottom: 1px solid #e2e8f0;
}

.features li:last-child {
  border-bottom: none;
}

.btn-pricing {
  display: block;
  text-align: center;
  padding: 1rem;
  border-radius: 8px;
  font-weight: 600;
  text-decoration: none;
  background: #edf2f7;
  color: #2d3748;
  transition: all 0.2s;
}

.btn-pricing:hover {
  background: #e2e8f0;
}

.btn-pricing.primary {
  background: #667eea;
  color: white;
}

.btn-pricing.primary:hover {
  background: #5568d3;
}

/* FAQ */
.faq-section {
  padding: 6rem 0;
}

.faq-section h2 {
  text-align: center;
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 3rem;
  color: #1a202c;
}

.faq-list {
  max-width: 800px;
  margin: 0 auto;
}

.faq-item {
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  margin-bottom: 1rem;
  cursor: pointer;
  transition: all 0.3s;
}

.faq-item:hover {
  border-color: #cbd5e0;
}

.faq-item.open {
  border-color: #667eea;
}

.faq-question {
  padding: 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.faq-question h4 {
  margin: 0;
  font-size: 1.125rem;
  font-weight: 600;
  color: #2d3748;
}

.faq-toggle {
  font-size: 1.5rem;
  font-weight: 700;
  color: #667eea;
  flex-shrink: 0;
  margin-left: 1rem;
}

.faq-answer {
  padding: 0 1.5rem 1.5rem 1.5rem;
  color: #4a5568;
  line-height: 1.6;
}

.faq-answer p {
  margin: 0;
}

/* Final CTA */
.final-cta {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 6rem 0;
  text-align: center;
}

.final-cta h2 {
  font-size: 3rem;
  font-weight: 800;
  margin-bottom: 1rem;
}

.final-cta p {
  font-size: 1.25rem;
  opacity: 0.95;
  margin-bottom: 2rem;
}

/* Prompt Library CTA */
.prompt-library-cta {
  background: linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%);
  padding: 4rem 2rem;
}

.prompt-library-cta .cta-card {
  background: white;
  border-radius: 16px;
  padding: 3rem;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  max-width: 1000px;
  margin: 0 auto;
  text-align: center;
}

.prompt-library-cta .cta-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 1.5rem;
}

.prompt-library-cta .cta-badge svg {
  width: 1.25rem;
  height: 1.25rem;
}

.prompt-library-cta h2 {
  font-size: 2.5rem;
  font-weight: 700;
  color: #2d3748;
  margin-bottom: 1rem;
}

.prompt-library-cta .cta-description {
  font-size: 1.125rem;
  color: #4a5568;
  line-height: 1.6;
  max-width: 700px;
  margin: 0 auto 2.5rem;
}

.prompt-library-cta .cta-features {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
  margin-bottom: 2.5rem;
  text-align: left;
}

.prompt-library-cta .feature {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1.25rem;
  background: linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%);
  border-radius: 12px;
  transition: transform 0.2s, box-shadow 0.2s;
}

.prompt-library-cta .feature:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.prompt-library-cta .feature-icon {
  font-size: 2rem;
  flex-shrink: 0;
}

.prompt-library-cta .feature-text {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.prompt-library-cta .feature-text strong {
  color: #2d3748;
  font-size: 1rem;
  font-weight: 600;
}

.prompt-library-cta .feature-text span {
  color: #718096;
  font-size: 0.875rem;
}

.prompt-library-cta .cta-button {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 1rem 2rem;
  border-radius: 8px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s;
  font-size: 1.125rem;
}

.prompt-library-cta .cta-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.3);
}

@media (max-width: 968px) {
  .hero {
    padding: 3rem 0;
  }

  .hero-logo {
    width: 100px;
    height: 100px;
  }

  .status-banner {
    flex-direction: column;
    gap: 1rem;
    align-items: center;
  }

  .status-item {
    width: 100%;
    max-width: 300px;
    justify-content: center;
  }

  .hero-content,
  .setup-content,
  .pricing-grid,
  .prompts-grid {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .prompt-library-cta .cta-features {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .prompt-library-cta .cta-card {
    padding: 2rem 1.5rem;
  }

  .prompt-library-cta h2 {
    font-size: 1.75rem;
  }

  .hero h1 {
    font-size: 2rem;
    margin-bottom: 1rem;
  }

  .subtitle {
    font-size: 1rem;
    margin-bottom: 1.5rem;
  }

  .cta-buttons {
    flex-direction: column;
    gap: 0.75rem;
  }

  .btn-primary, .btn-secondary {
    width: 100%;
    justify-content: center;
    padding: 0.875rem 1.5rem;
    font-size: 1rem;
  }

  .trust-signals {
    flex-wrap: wrap;
    gap: 1.5rem;
    justify-content: space-around;
  }

  .trust-item strong {
    font-size: 1.5rem;
  }

  .hero-demo {
    display: none;
  }

  .steps {
    flex-direction: column;
  }

  .step-arrow {
    transform: rotate(90deg);
  }

  .setup-content.reverse {
    grid-template-columns: 1fr;
  }

  .setup-content.reverse .setup-visual {
    order: -1;
  }
}
</style>
